import React from "react";
import Documents from "./Documents";
import Milestones from "./Milestones";
import { default as Forms } from "./CaseForms";
import Box from "@material-ui/core/Box";
import CaseWebsiteContext from "../context/websitecontext";
import { ICaseData } from "../types";


const Sidebar: React.FC = () => {
  const context = React.useContext<ICaseData>(CaseWebsiteContext);

  const {
    CaseWebsiteDocuments,
    CaseWebsiteMilestones,
    CaseForms,
  } = context.data;


  return (
    <Box>
      {CaseForms && CaseForms.length > 0 &&
        <Forms forms={CaseForms} />}

      {CaseWebsiteDocuments && CaseWebsiteDocuments.length > 0 &&
        <Documents documents={CaseWebsiteDocuments} />}

      {CaseWebsiteMilestones && CaseWebsiteMilestones.length > 0 &&
        <Milestones milestones={CaseWebsiteMilestones} />}
    </Box>
  );
};

export default React.memo(Sidebar);
